
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9.999 7.758a2 2 0 11.003 4 2 2 0 01-.003-4zm-7.495 4.126l.632.158c.512.127.948.457 1.21.913l.046.08c.274.46.345 1.009.198 1.524l-.179.627a.665.665 0 00.306.76l2.565 1.48a.669.669 0 00.812-.113l.474-.494a1.968 1.968 0 011.42-.595h.022a1.964 1.964 0 011.42.595l.476.494a.67.67 0 00.812.114l2.563-1.48a.666.666 0 00.308-.761l-.18-.627a1.935 1.935 0 01.2-1.524c.014-.026.03-.052.044-.08a1.932 1.932 0 011.211-.913l.632-.158a.666.666 0 00.504-.646V8.279a.668.668 0 00-.504-.648l-.632-.158a1.926 1.926 0 01-1.21-.913l-.046-.08a1.935 1.935 0 01-.198-1.524l.179-.627a.667.667 0 00-.308-.76l-2.563-1.48a.67.67 0 00-.812.113l-.476.494c-.37.384-.886.597-1.42.597h-.022a1.978 1.978 0 01-1.42-.597l-.474-.494a.67.67 0 00-.812-.114l-2.565 1.48a.666.666 0 00-.306.761l.18.627a1.935 1.935 0 01-.2 1.524l-.044.08a1.932 1.932 0 01-1.211.913l-.632.158A.668.668 0 002 8.279v2.959c0 .306.207.571.504.646z"}})])
          )
        }
      }
    